var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('rem-container',{attrs:{"min-width":1650}},[_c('comm-header'),_c('router-view'),_c('comm-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }